<template>
  <v-col v-bind="containerOptions" cols="12">
    <h2
      :id="$attrs.id"
      :class="classes"
    >
      <b :class="colors.text">{{ chapter }}</b>
      {{ $attrs.label }}
    </h2>
  </v-col>
</template>

<script>
export default {
  name: 'HelmiTitle',

  inheritAttrs: false,

  props: {
    chapter: {
      type: String,
      default: '',
    },

    classes: {
      type: String,
      default: '',
    },

    colors: {
      type: Object,
      default: () => ({
        base: 'primary',
        text: 'primary--text',
      }),
    },

    containerOptions: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
